import "core-js/modules/es.array.sort.js";
import React from 'react';
import { EnrollmentCourseStructureSubtrainingProgramComponent } from "./enrollment-course-structure-subtraining-program.component";
export const EnrollmentCourseStructureTrainingProgramComponent = props => {
  const {
    CourseCard,
    enrollmentTrainingProgram
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("h2", null, enrollmentTrainingProgram.name)), enrollmentTrainingProgram.enrollmentSubtrainingPrograms.filter(x => !x.parentId).sort((a, b) => a.order - b.order).map((x, i) => /*#__PURE__*/React.createElement(EnrollmentCourseStructureSubtrainingProgramComponent, {
    key: i,
    CourseCard: CourseCard,
    subtrainingProgram: x,
    allsubtrainingPrograms: enrollmentTrainingProgram.enrollmentSubtrainingPrograms,
    level: 0
  })));
};